import { jsx } from 'react/jsx-runtime';

const SvgArrowSmallRight = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M11.44 5H8.82l5.88 7-5.88 7h2.62l5.86-7-5.86-7Z" }) }));

export { SvgArrowSmallRight as default };
//# sourceMappingURL=ArrowSmallRight.es.js.map
